import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { EmployeeService } from 'src/app/services/employee.service';
import { UtilsService } from 'src/app/services/utils.service';
import { PermissionService } from 'src/app/services/permission.service';
import { SAT_WORK_SCHEDULE_TYPES } from '../fiscal-tab/fiscal-tab.component';

@Component({
    selector: 'app-imss-tab',
    templateUrl: './imss-tab.component.html',
    styleUrls: ['./imss-tab.component.css', '../employee-tab-shared.css']
})
export class ImssTabComponent implements OnInit {
    @Input() employee: any;
    @Output() saved = new EventEmitter<any>();
    @Output() goToFiscal = new EventEmitter<void>();

    form!: FormGroup;

    employeeTypes = ['Confianza', 'Sindicalizado', 'Base', 'Eventual', 'Honorarios'];
    workScheduleTypes = SAT_WORK_SCHEDULE_TYPES;
    shifts = ['Matutino', 'Vespertino', 'Nocturno', 'Mixto'];

    constructor(
        private fb: FormBuilder,
        private employeeService: EmployeeService,
        private utils: UtilsService,
        private spinner: NgxSpinnerService,
        private permissionService: PermissionService
    ) { }

    canDo(action: string): boolean {
        return this.permissionService.canDo('Listado de colaboradores', action);
    }

    ngOnInit(): void {
        this.form = this.fb.group({
            employee_type: [this.employee?.employee_type || ''],
            employer_registration: [this.employee?.employer_registration || ''],
            contract_start_date: [this.toDateInputValue(this.employee?.contract_start_date)],
            contract_end_date: [this.toDateInputValue(this.employee?.contract_end_date)],
            work_schedule_type: [this.employee?.work_schedule_type || ''],
            shift: [this.employee?.shift || ''],
            medical_unit: [this.employee?.medical_unit || ''],
            alimony_discount: [!!this.employee?.alimony_discount]
        });
    }

    toDateInputValue(value: any): string {
        if (!value) return '';
        return String(value).substring(0, 10);
    }

    formatDate(value: any): string {
        if (!value) return '—';
        const datePart = String(value).substring(0, 10);
        const [yyyy, mm, dd] = datePart.split('-');
        if (!yyyy || !mm || !dd) return '—';
        return `${dd}/${mm}/${yyyy}`;
    }

    save(): void {
        const payload: any = {
            ...this.form.value,
            contract_start_date: this.form.value.contract_start_date || null,
            contract_end_date: this.form.value.contract_end_date || null
        };

        this.spinner.show();
        this.employeeService.update(this.employee.id, payload).subscribe({
            next: (resp: any) => {
                this.spinner.hide();
                this.utils.alertSwal({ title: 'Operación exitosa', text: 'La información de IMSS se guardó correctamente', icon: 'success' });
                this.saved.emit(resp);
            },
            error: () => {
                this.spinner.hide();
                this.utils.alertSwal({ title: 'Error', text: 'No se pudo guardar la información', icon: 'error' });
            }
        });
    }
}
